import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bdc25c00"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-4xl mt-4" }
const _hoisted_2 = { class: "mt-2 mb-4" }
const _hoisted_3 = { class: "text-sm text-gray-400" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("I work for "),
  /*#__PURE__*/_createElementVNode("strong", { class: "text-red-500" }, "*")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode("I preferred "),
    /*#__PURE__*/_createElementVNode("strong", { class: "text-red-500" }, "*")
  ])
], -1))
const _hoisted_6 = { class: "col-span-2 mb-8" }
const _hoisted_7 = { class: "my-4 text-sm text-gray-400" }

import { ref, reactive } from 'vue';
import { Notify } from 'quasar';
import { create } from 'src/api/ProductRegistration';
import { useI18n } from 'vue-i18n';

export default /*#__PURE__*/_defineComponent({
  __name: 'ProductRegisterPage',
  emits: ["success"],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();

const registerLoading = ref(false);

const emit = __emit;

const setCookie = (name: string, value: string, days: number) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
};

const countryCodes = ref([
  { label: '+86 (CN)', value: '86' },    // 中国
  { label: '+852 (HK)', value: '852' },  // 香港
  { label: '+853 (MO)', value: '853' },  // 澳门
  { label: '+886 (TW)', value: '886' },  // 台湾
  { label: '+1 (US)', value: '1' },      // 美国
  { label: '+1 (CA)', value: '1' },      // 加拿大
  { label: '+44 (UK)', value: '44' },    // 英国
  { label: '+81 (JP)', value: '81' },    // 日本
  { label: '+82 (KR)', value: '82' },    // 韩国
  { label: '+91 (IN)', value: '91' },    // 印度
  { label: '+60 (MY)', value: '60' },    // 马来西亚
  { label: '+65 (SG)', value: '65' },    // 新加坡
  { label: '+61 (AU)', value: '61' },    // 澳大利亚
  { label: '+7 (RU)', value: '7' },      // 俄罗斯
  { label: '+49 (DE)', value: '49' },    // 德国
  { label: '+33 (FR)', value: '33' },    // 法国
  { label: '+39 (IT)', value: '39' },    // 意大利
  { label: '+34 (ES)', value: '34' },    // 西班牙
  { label: '+55 (BR)', value: '55' },    // 巴西
  { label: '+54 (AR)', value: '54' },    // 阿根廷
  { label: '+62 (ID)', value: '62' },    // 印尼
  { label: '+66 (TH)', value: '66' },    // 泰国
  { label: '+84 (VN)', value: '84' },    // 越南
  { label: '+63 (PH)', value: '63' },    // 菲律宾
]);

// 注册表单
const model = reactive({
  company: '',
  email: '',
  countryCode: '86',
  whatsapp: '',
  contactType: 'Email',
  isUnlocked: false
});

// 处理注册
const handleRegister = async () => {
  registerLoading.value = true;
  try {
    if(model.contactType === 'Email'){
        model.contactType = '';
    }
    await create({
      ...model,
    });

    // 模拟注册成功
    await new Promise(resolve => setTimeout(resolve, 1000));
  
     setCookie('product_unlocked', 'true', 7);
     setCookie('user_email', model.email, 7);

    Notify.create({
      message:t('ProductRegister.registerSuccess'),
      type: 'positive',
    });

    // 重置表单
    model.company = '';
    model.email = '';
    model.whatsapp = '';
    model.contactType = 'Email';
    model.contactType = '86';
    emit('success');

  } catch (error) {
    Notify.create({
      message: t('ProductRegister.registerError'),
      type: 'negative',
    });
  } finally {
    registerLoading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_radio = _resolveComponent("q-radio")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, { class: "flex justify-center" }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, {
        style: {"max-width":"515px"},
        class: "wireless-card px-8"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "items-center q-pb-none" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('ProductRegister.register')), 1),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('ProductRegister.description')), 1)
              ]),
              _createVNode(_component_q_space)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_form, {
                onSubmit: handleRegister,
                class: "q-gutter-md pt-4"
              }, {
                default: _withCtx(() => [
                  _hoisted_4,
                  _createVNode(_component_q_input, {
                    modelValue: model.company,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model.company) = $event)),
                    class: "mb-8",
                    label: _unref(t)('ProductRegister.company'),
                    rules: [val => !!val || _unref(t)('ProductRegister.company')+ _unref(t)('ProductRegister.required')],
                    outlined: "",
                    dense: ""
                  }, null, 8, ["modelValue", "label", "rules"]),
                  _hoisted_5,
                  _createVNode(_component_q_radio, {
                    modelValue: model.contactType,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model.contactType) = $event)),
                    val: "Email",
                    label: _unref(t)('ProductRegister.email')
                  }, null, 8, ["modelValue", "label"]),
                  _createVNode(_component_q_radio, {
                    modelValue: model.contactType,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((model.contactType) = $event)),
                    val: "WhatsApp",
                    label: _unref(t)('ProductRegister.whatsapp'),
                    class: "q-ml-md"
                  }, null, 8, ["modelValue", "label"]),
                  (model.contactType === 'Email')
                    ? (_openBlock(), _createBlock(_component_q_input, {
                        key: 0,
                        modelValue: model.email,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((model.email) = $event)),
                        class: "mb-8",
                        label: _unref(t)('ProductRegister.email'),
                        type: "email",
                        rules: [
                    val => !!val || _unref(t)('ProductRegister.email') + _unref(t)('ProductRegister.required'),
                    val => /.+@.+\..+/.test(val) || _unref(t)('ProductRegister.invalid') + _unref(t)('ProductRegister.email')
                ],
                        outlined: "",
                        dense: ""
                      }, null, 8, ["modelValue", "label", "rules"]))
                    : (_openBlock(), _createBlock(_component_q_input, {
                        key: 1,
                        modelValue: model.whatsapp,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((model.whatsapp) = $event)),
                        class: "mb-8",
                        label: _unref(t)('ProductRegister.whatsappinput'),
                        type: "tel",
                        rules: [
                    val => !!val || _unref(t)('ProductRegister.whatsappinput') + _unref(t)('ProductRegister.required'),
                    val => /^\+?[0-9]{6,15}$/.test(val) || _unref(t)('ProductRegister.invalid') + _unref(t)('ProductRegister.whatsappinput')
                ],
                        outlined: "",
                        dense: ""
                      }, {
                        before: _withCtx(() => [
                          _createVNode(_component_q_select, {
                            modelValue: model.countryCode,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((model.countryCode) = $event)),
                            options: countryCodes.value,
                            dense: "",
                            outlined: "",
                            "emit-value": "",
                            "map-options": "",
                            class: "w-36 mr-2"
                          }, {
                            option: _withCtx((scope) => [
                              _createVNode(_component_q_item, _mergeProps(scope.itemProps, {
                                class: "text-xs",
                                style: {"min-height":"1rem"}
                              }), {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(scope.opt.label), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1040)
                            ]),
                            _: 1
                          }, 8, ["modelValue", "options"])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "label", "rules"])),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_q_btn, {
                      label: _unref(t)('ProductRegister.submit'),
                      type: "submit",
                      class: "w-full h-12",
                      "no-caps": "",
                      color: "linear-color2",
                      loading: registerLoading.value
                    }, null, 8, ["label", "loading"])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)('ProductRegister.hint')), 1)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})